/** @jsx jsx */

import React from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';

const { lPink, lGrey0 } = colors;

const EmptyBtn = ({
  label,
  ariaLabel = '',
  disabled,
  onClick,
  style = {},
  ...props
}: {
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  style?: {};
  onClick?: any;
}) => {
  //
  return (
    <button
      css={css`
        padding: 0;
        border: none;
        //
        font: inherit;
        color: inherit;
        background-color: transparent;
        cursor: pointer;

        // https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible
        &:focus-visible {
          outline: 1px solid ${lPink};
          outline-offset: 3px;
        }
      `}
      style={style}
      {...props}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {label}
    </button>
  );
};

export default EmptyBtn;
